function SamePriceController ($routeParams, RequestService, CityConfigService, CartService)
{
    "ngInject";

    var vm = this;

    vm.cartService = CartService;
    vm.samePriceProducts = [];
    vm.samePriceProductsLoaded = false;

    vm.loadCatalogItems = function () {
        vm.samePriceProductsLoaded = false;

        var data = {
            request: 'getSamePriceGoods',
            limitPerPage: 4,
            itemId: $routeParams.itemId
        };

        RequestService.processRequest(CityConfigService.options.city.base_url + "/api/handler.php", data)
            .then(function (response) {
                vm.samePriceProducts = response.data.data;
                vm.samePriceProductsLoaded = true;
            })
            .catch(function (error) {
                console.error('Ошибка загрузки похожих товаров', error);
                vm.samePriceProductsLoaded = true;
            });
    };

    vm.$onInit = function () {
        vm.loadCatalogItems();
    };
}

module.exports = SamePriceController;